import { base as authBase } from '../reducer/auth';

export default (store) => (next) => (action) => {
  if (action.meta && action.meta.auth && action.meta.auth.needsToken) {
    // get auth state
    const state = store.getState()[authBase];

    // merge auth state in auth meta
    action.meta.auth = { ...action.meta.auth, ...state };
  }

  return next(action);
};
